export default __webpack_public_path__ + "static/media/inspirational-msg.e63bb13c.jpg";